import {Component, Input} from '@angular/core';

@Component({
    selector: 'nz-user-rating',
    imports: [],
    templateUrl: './user-rating.component.html',
    styleUrl: './user-rating.component.scss'
})
export class UserRatingComponent {
  @Input() rating: number = 0;
  @Input() hiddenValue : boolean = false;
}
